import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const About = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${layout.spacing.small};

  a {
    color: ${p => p.theme.text.callToAction};

    &:hover {
      color: ${p => p.theme.text.callToActionHover};
    }
  }

  svg {
    margin-right: ${layout.spacing.xxSmall};
  }
`;
